<template>
    <div>
        <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
        <div class="chain_RelatedReport">
            <h2 class="chain_title1">全国{{ baseInfo.title }}市场规模</h2>
            <div>
                <div class="market-box w95mg oh" v-if="!isChainDetail">
                    <div v-for="(list, i) in marketList" :key="i" class="fl market-list mb-2" >
                        <h4 class="mt-1 market-title font-16" @click="routerblank('/marketDetail?type=1&id='+list.id)">{{ list.title }}</h4>
                        <div style="width: 90%;height: 290px;margin: 0 auto;" :id="'bar_charts_' + i"></div>
                    </div>
                </div> 
                <div class="market-box w95mg"  v-if="isChainDetail">
                    <div class="chain-detail-market oh">
                        <div class="fl chain-detail-box">
                            <div v-for="(list, i) in marketList" :key="i" class="market-list mb-2">
                            <h4 class="mt-1 market-title font-16" @click="routerblank('/marketDetail?type=1&id='+list.id)">{{ list.title }}</h4>
                            <div style="width: 90%;height: 290px;margin: 0 auto;" :id="'bar_charts_' + i"></div>
                            </div>
                        </div>
                        <div class="fr">
                            <div class="chain_free">
                                <freeUserTips :type="4" :bgtype="41" :isShowDownFile="true"></freeUserTips>
                            </div>
                        </div>
                 </div>
                </div>
                
			    <!-- <p class="text-center my-2 curp widthPC-100 font-18" @click="routerblank('/industryLibrary?type=2&code='+baseInfo.notionList)">更多信息 ></p> -->
			    <p class="text-center my-2 curp widthPC-100 font-18" @click="freeRtouer()">更多信息 ></p>
            </div>
        </div>
    </div>
</template>
<script>
import { type } from 'jquery';


export default {
    data() {
        return {
            isShowFreeUserTips: false
        }
    },
    props: {
        userdata: { type: Object, default: {} },
        baseInfo:{ type:Object,default:{} },
        marketList:{type:Array,default:[]},
        isChainDetail:{type:Boolean,default:false}
    },
    mounted() { 
        this.init();
    },
    methods: {
        freeRtouer(){
          this.isShowFreeUserTips = true;
        },
        init() { 
            if(this.marketList.length>0){
            setTimeout(() => {
                console.log('marketlist',this.marketList);
                    this.marketList.forEach((list, i) => {
                        this.drawShape('bar_charts_'+i,list.dataList,list.legendName,list.unit);
                    })
            },500)
            }
            
        },
        drawShape(el, data, legendName, unit) {
            // console.log(el,data,legendName,unit);
            let xAxisText = [];
            let barData = [], //柱状
                lineData = []; //折线
            for (var i = 0; i < data.length; i++) {
                    xAxisText.push(data[i].label);
                    barData.push(data[i].value);
                    lineData.push(data[i].tb); 
            }
            // 创建立方体正面图形
            const cubeShape1 = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                    width: 10, // 长方体宽度
                    zWidth: 2, // 阴影折角高
                    zHeight: 4 // 阴影折角宽
                },
                buildPath: (ctx, shape) => {
                    const api = shape.api
                    const xAxisPoint = api.coord([shape.xValue, 0])
                    const p0 = [shape.x, shape.y]
                    const p1 = [shape.x - shape.width, shape.y]
                    const p4 = [shape.x + shape.width, shape.y]
                    const p2 = [
                        xAxisPoint[0] - shape.width,
                        xAxisPoint[1]
                    ]
                    const p3 = [
                        xAxisPoint[0] + shape.width,
                        xAxisPoint[1]
                    ]

                    // 绘制正面
                    ctx.moveTo(p0[0], p0[1]) //0
                    ctx.lineTo(p1[0], p1[1]) //1
                    ctx.lineTo(p2[0], p2[1]) //2
                    ctx.lineTo(p3[0], p3[1]) //3
                    ctx.lineTo(p4[0], p4[1]) //4
                    ctx.lineTo(p0[0], p0[1]) //0
                    ctx.closePath()
                }
            })

            // 创建立方体的侧面
            const cubeShape2 = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                    width: 10, // 长方体宽度
                    zWidth: 4, // 阴影折角高
                    zHeight: 1 // 阴影折角宽
                },
                buildPath: (ctx, shape) => {
                    const api = shape.api
                    const xAxisPoint = api.coord([shape.xValue, 0])
                    const p4 = [shape.x + shape.width, shape.y]
                    const p6 = [
                        shape.x + shape.width + shape.zWidth,
                        shape.y - shape.zHeight
                    ]
                    const p3 = [
                        xAxisPoint[0] + shape.width,
                        xAxisPoint[1]
                    ]
                    const p5 = [
                        xAxisPoint[0] + shape.width + shape.zWidth,
                        xAxisPoint[1] - shape.zHeight
                    ]

                    // 绘制侧面
                    ctx.moveTo(p4[0], p4[1]) //4
                    ctx.lineTo(p3[0], p3[1]) //3
                    ctx.lineTo(p5[0] + 6, p5[1] - 6) //5
                    ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
                    ctx.lineTo(p4[0], p4[1]) //4
                    ctx.closePath()
                }
            })
            // 创建立方体的顶
            const cubeShape3 = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                    width: 10,
                    zWidth: 4,
                    zHeight: 1
                },
                buildPath: (ctx, shape) => {
                    const api = shape.api
                    const p1 = [shape.x - shape.width, shape.y]
                    const p4 = [shape.x + shape.width, shape.y]
                    const p6 = [
                        shape.x + shape.width + shape.zWidth,
                        shape.y - shape.zHeight
                    ]
                    const p7 = [
                        shape.x - shape.width + shape.zWidth,
                        shape.y - shape.zHeight
                    ]
                    // 绘制顶部
                    ctx.moveTo(p4[0], p4[1]) //4
                    ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
                    ctx.lineTo(p7[0] + 7, p7[1] - 8) //7
                    ctx.lineTo(p1[0], p1[1]) //1
                    ctx.lineTo(p4[0], p4[1]) //4
                    ctx.closePath()
                }
            })

            echarts.graphic.registerShape('cubeShape1', cubeShape1);
            echarts.graphic.registerShape('cubeShape2', cubeShape2);
            echarts.graphic.registerShape('cubeShape3', cubeShape3); 
            this.initECharts(el, xAxisText, lineData, barData, legendName, unit);
        },
        initECharts(el, xdata, lineData, barData, legendName, unit) {
            var mychart = echarts.init(document.getElementById(el));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    grid: {
                        top: '100%',
                        // containLabel: true // 包含标签
                    },
                    // confine:true, //是否将提示框限制在图表的区域内
                    appendToBody: true, //是否将提示框放置在body元素上
                    formatter: function (params) {
                        // console.log(params);
                        var result = ''
                        var name = params[0].name + "</br>";
                        var dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType == "line" ? ' %' : unit;
                        if (params[0]) {
                            dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + params[0].data + ' ' + unitd + "</br>"; // 定义第一个数据前的圆点颜色	
                        }
                        if (params[1]) {
                            dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + params[1].data + ' %';
                        }

                        result += name + dotHtml + dotHtml2;
                        return result
                    },
                },
                legend: {
                    show: true,
                    bottom: "5%",
                },
                xAxis: {
                    type: 'category',
                    data: xdata,
                    interval: 0,
                    axisLine: {
                        onZero: false,
                    }
                    // axisLabel: { color: '#333', interval: 0, rotate: 50 }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        boundaryGap: false,
                        // step:
                        axisTick: {
                            "show": true
                        },
                        axisLine: {
                            show: true,
                        }, //显示y轴刻度线
                        splitLine: {
                            show: false
                        }, //不显示分割线
                    },
                    {
                        type: 'value',
                        name: ' ',
                        axisTick: {
                            "show": true
                        },
                        splitLine: {
                            show: false
                        }, //不显示分割线
                        axisLine: {
                            show: true,
                        }, //显示y轴刻度线
                        axisLabel: {
                            // 使用 formatter 属性来格式化标签文本
                            formatter: '{value} %' // 在这里添加单位
                        }
                    }
                ],
                series: [
                    {
                        type: 'custom',
                        name: legendName,
                        color: 'rgb(96, 147, 218)',
                        renderItem: (params, api) => {
                            // console.log(params,api)
                            let location = api.coord([api.value(0), api.value(1)]);
                            return {
                                type: 'group',
                                children: [{
                                    type: 'cubeShape1', // 正方体正面
                                    shape: {
                                        api,
                                        xValue: api.value(0),
                                        yValue: api.value(1),
                                        x: location[0],
                                        y: location[1]
                                    },
                                    style: {
                                        fill: 'rgb(96, 147, 218)'
                                    }
                                },
                                {
                                    type: 'cubeShape2', // 正方体侧面
                                    shape: {
                                        api,
                                        xValue: api.value(0),
                                        yValue: api.value(1),
                                        x: location[0],
                                        y: location[1]
                                    },
                                    style: {
                                        fill: 'rgb(84,128,191)'
                                    }
                                },
                                {
                                    type: 'cubeShape3', // 正方体顶
                                    shape: {
                                        api,
                                        xValue: api.value(0),
                                        yValue: api.value(1),
                                        x: location[0],
                                        y: location[1]
                                    },
                                    style: {
                                        fill: 'rgb(104, 161, 236)'
                                    }
                                },
                                ]
                            }
                        },
                        yAxisIndex: 0, // 这里指定使用第一个 Y 轴
                        data: barData,
                    },
                    {
                        name: 'YOY',
                        type: 'line',
                        yAxisIndex: 1,
                        color: '#ffaf25',
                        data: lineData
                    }
                ]
            }
            mychart.setOption(option)
        },
    }
}
</script>
<style lang="scss" scoped>
.chain-detail-market{
    .chain-detail-box{
        width:462px;
        .market-list{
            width: 100%;
        }
    }
}
.chain_free{
    width: 1000px;
    height: 780px;
    .freeUserTips{
        height: 770px;
    }
}
.container-flex-center img{
	max-width: 95%;
	max-height: 95%;
}
.el-dialog__headerbtn{
	font-size: 30px;
	font-weight: bold;
}
.pop-box{
	width:100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	border: 1px solid red;
	z-index: 99999;
}
.market-list{
	width: calc(33% - 35px);
    height: 365px;
    cursor: pointer;
    overflow: hidden;
    transition: all .3s;
    border: 1px solid #eee;
    margin-right: 35px;
    border-radius: 8px;
}
.market-list:hover{
	/* background: #f3f7ff; */
	border-radius: 8px;

}
.image-card{
	height: 270px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.market-title{
	padding: 20px 20px 0 20px;
	height: 48px;
	/* display: flex; */
    /* align-items: center; */
	/* overflow: hidden; */
}
</style>